import React from 'react';

import Box from '@material-ui/core/Box';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginBottom: theme.spacing(2),
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gridGap: theme.spacing(1),
    flexWrap: 'wrap',
    maxWidth: '100%',
  },
  // Ellipsis only engages once every flex ancestor is allowed to shrink.
  truncated: {
    minWidth: 0,
    maxWidth: '80%',
    overflow: 'hidden',
  },
}));

export interface DaasSectionItemProps {
  icon?: React.ReactNode;
  title?: React.ReactNode;
  subTitle?: React.ReactNode;
  badges?: React.ReactNode;
  children?: React.ReactNode;
  /** Clip an overlong title to the row and show it in full on hover. */
  truncate?: boolean;
}

export const DaasSectionItem = ({
  icon,
  title,
  subTitle,
  badges,
  children,
  truncate = false,
}: DaasSectionItemProps) => {
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Box className={classes.header}>
        {icon}
        {title && (
          <Box
            display="flex"
            flexDirection="column"
            className={truncate ? classes.truncated : undefined}
          >
            <Tooltip title={truncate ? title : ''} placement="top-start">
              <Typography variant="body2" noWrap={truncate}>
                {title}
              </Typography>
            </Tooltip>
            {subTitle && (
              <Typography
                variant="caption"
                color="textSecondary"
                style={{ fontFamily: 'monospace' }}
              >
                {subTitle}
              </Typography>
            )}
          </Box>
        )}
        {badges}
      </Box>
      {children && (
        <Box flex={1} minWidth={0} ml={title ? 4 : 0}>
          {children}
        </Box>
      )}
    </Box>
  );
};
